module.exports = __webpack_public_path__ + "img/Dual Ball-1s-200px.a9643e48.gif";